import { render, staticRenderFns } from "./sportageace-imgs-swiper.vue?vue&type=template&id=1e5726ec&scoped=true&"
import script from "./sportageace-imgs-swiper.vue?vue&type=script&lang=js&"
export * from "./sportageace-imgs-swiper.vue?vue&type=script&lang=js&"
import style0 from "./sportageace-imgs-swiper.vue?vue&type=style&index=0&id=1e5726ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5726ec",
  null
  
)

export default component.exports